import TasksContent from "page_components/webmaster/tasks/Content";
import TasksProvider from "context/webmaster/tasks";

const Tasks = () => (
  <TasksProvider>
    <TasksContent />
  </TasksProvider>
);

export default Tasks;
